import FormulateOskTextPassword from './FormulateOskTextPassword.vue'

export default function VueFormulateOskTextPasswordPlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateOskTextPassword,
    },
    library: {
      'osk-text-password': {
        classification: 'text',
        component: 'FormulateOskTextPassword',
        slotProps: {
          component: ['oskType'],
        },
      },
    },
  })
}
